import { Icon } from "@design-system/Icon";
import { cn } from "@design-system/Utilities";
import { type ButtonHTMLAttributes, type FC } from "react";
import { useAtomValue } from "jotai";
import { currentUserLocaleAtom } from "@app/store/userStore";
export const HelpButton: FC<
    ButtonHTMLAttributes<HTMLButtonElement> & {
        dataChameleonKey: string;
        theme?: "dark" | "light";
    }
> = ({ dataChameleonKey, theme = "light", ...props }) => {
    const locale = useAtomValue(currentUserLocaleAtom);
    return (
        <button
            id={`header-help-button-${dataChameleonKey}-${locale ?? "fr"}`}
            data-chameleon={`header-help-button-${dataChameleonKey}`}
            {...props}
        >
            <Icon
                name="circleHelp"
                className={cn(
                    theme === "light" ? "text-secondary" : "text-white",
                )}
            />
        </button>
    );
};
